// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/common/type/v1/form_template.proto (package fingertip.common.type.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { Media } from "./media_pb.js";

/**
 * @generated from message fingertip.common.type.v1.FormTemplate
 */
export const FormTemplate = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.FormTemplate",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "site_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "created_at", kind: "message", T: Timestamp },
    { no: 6, name: "updated_at", kind: "message", T: Timestamp },
    { no: 7, name: "form_in_use", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "response_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "form_theme_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "banner_media", kind: "message", T: Media },
    { no: 12, name: "thank_you_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "button_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "custom_recipients", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 15, name: "use_custom_recipients", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

